import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { clearException, closeException } from 'actions/exceptions/clearException';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Button from 'components/Common/Buttons';

class Notifications extends Component {
  clear(index) {
    const { dispatch } = this.props;
    dispatch(closeException(index));
    dispatch(clearException(index));
  }

  render() {
    const { notifs, intl } = this.props;

    return (
      notifs != null && notifs.length > 0 && <section className="container notifs">
        <div className="row">
          <div className="col">
            { notifs.map((item, i) => <div key={ item.id } className={ `notif error ${ item.closing ? 'closing' : '' }` }>
              { `${ item.code } - ${ item.message }`}
              <Button
                text=""
                value="Close"
                className="close"
                onClick={ () => this.clear(i) }
                ariaLabel={ intl.formatMessage({ id: 'accessibility.notification.close' }) }
              >
                <FontAwesomeIcon icon="times" />
              </Button>
            </div>)}
          </div>
        </div>
      </section>
    );
  }
}

Notifications.propTypes = {
  dispatch: PropTypes.func.isRequired,
  notifs: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.number,
    code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    message: PropTypes.string,
    adding: PropTypes.bool,
    closing: PropTypes.bool
  })),
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired
};

Notifications.defaultProps = {
  notifs: []
};

const mapDispatchToProps = dispatch => ({ dispatch });

function mapStateToProps(state) {
  const {
    exceptions: { items }
  } = state;

  return {
    notifs: items
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(Notifications));
